import { render, staticRenderFns } from "./BaseContainerWebWrapper.vue?vue&type=template&id=7d2795d8&scoped=true&lang=pug"
import script from "./BaseContainerWebWrapper.vue?vue&type=script&lang=js"
export * from "./BaseContainerWebWrapper.vue?vue&type=script&lang=js"
import style0 from "./BaseContainerWebWrapper.vue?vue&type=style&index=0&id=7d2795d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2795d8",
  null
  
)

export default component.exports